namespace Matrix.Data {
    export class TestGroupColumns {
        static columnsKey = 'Data.TestGroup';
    }
}
